"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_me_client_js_1 = require("@synisys/idm-me-client-js");
let MEServicesModule = class MEServicesModule {
};
MEServicesModule = __decorate([
    core_1.NgModule({
        providers: [
            idm_me_client_js_1.HttpMEClassifierService,
            idm_me_client_js_1.MEKbHttpService,
            { provide: idm_me_client_js_1.MeConfigService, useClass: idm_me_client_js_1.HttpMeConfigService },
            { provide: idm_me_client_js_1.NameTempalteService, useClass: idm_me_client_js_1.HttpNameTemplateService },
            { provide: idm_me_client_js_1.ClassifierDataService, useClass: idm_me_client_js_1.HttpClassifierDataService },
            { provide: idm_classifier_service_client_js_1.ClassifierHttpService, useExisting: idm_classifier_service_client_js_1.ClassifierService },
            { provide: idm_me_client_js_1.IndicatorService, useClass: idm_me_client_js_1.HttpIndicatorService },
            { provide: idm_me_client_js_1.FrameworkService, useClass: idm_me_client_js_1.HttpFrameworkService },
            { provide: idm_me_client_js_1.IFService, useClass: idm_me_client_js_1.HttpIFService },
            { provide: idm_me_client_js_1.DisaggregationService, useClass: idm_me_client_js_1.HttpDisaggregationService },
            { provide: idm_me_client_js_1.QuestionService, useClass: idm_me_client_js_1.HttpQuestionService },
            { provide: idm_me_client_js_1.CommonServicesProviderService, useClass: idm_me_client_js_1.HttpCommonServicesProviderService },
        ]
    })
], MEServicesModule);
exports.MEServicesModule = MEServicesModule;
//# sourceMappingURL=me-services.module.js.map